import Enumerator from '../global/Enumerator';

export const assetFinanceProductTypes = [
  'none',
  'chattel_mortgage',
  'lease',
  'novated_lease',
  'consumer_loan_nccp',
  'rental',
  'insurance_premium_financed',
  'operating_lease',
  'escrow'
];

export class AssetFinanceProductType extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'chattel_mortgage';
        break;
      case '2':
        correctOption = 'lease';
        break;
      case '3':
        correctOption = 'novated_lease';
        break;
      case '4':
        correctOption = 'consumer_loan_nccp';
        break;
      case '5':
        correctOption = 'insurance_premium_financed';
        break;
      case '6':
        correctOption = 'rental';
        break;
      case '7':
        correctOption = 'operating_lease';
        break;
      case '8':
        correctOption = 'escrow';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

AssetFinanceProductType.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  chattel_mortgage: {
    get title() {
      return 'Chattel mortgage';
    }
  },
  lease: {
    get title() {
      return 'Lease';
    }
  },
  novated_lease: {
    get title() {
      return 'Novated lease';
    }
  },
  consumer_loan_nccp: {
    get title() {
      return 'Consumer loan (NCCP)';
    }
  },
  rental: {
    get title() {
      return 'Rental';
    }
  },
  insurance_premium_financed: {
    get title() {
      return 'IPF';
    }
  },
  operating_lease: {
    get title() {
      return 'Operating lease';
    }
  },
  escrow: {
    get title() {
      return 'Escrow';
    }
  }
});

export default {
  assetFinanceProductTypes,
  AssetFinanceProductType
};
